import React, { useEffect, useState } from 'react';
import { useField } from 'react-final-form';

import * as Styled from './TextArea.styled';

export interface TextAreaProps {
  className?: string;
  name: string;
  fieldName: string;
  placeholder?: string;
  valid?: boolean | null;
  /* eslint-disable no-unused-vars */
  validator: (value: string) => string | undefined;
  onBlur?: () => void;
  /* eslint-disable no-unused-vars */
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onValidate?: (result: {
    name: string;
    valid: boolean;
    message?: string;
  }) => void;
}

export const TextArea: React.FC<TextAreaProps> = ({
  className,
  name,
  fieldName,
  placeholder = '',
  validator,
}) => {
  const [errors, setErrors] = useState<string[]>([]);

  const {
    input,
    meta: { error, touched, active },
  } = useField(fieldName, {
    validate: value => validator(value),
  });

  useEffect(() => {
    if (!active && error && touched) {
      if (errors.includes(error)) return;

      setErrors([...errors, error]);
    }
  }, [error, touched, errors, active]);

  // Only show error when field is not active and has been touched
  const shouldShowError = !active && error && touched;

  return (
    <Styled.Wrapper className={className}>
      <Styled.TextAreaContainer error={shouldShowError}>
        <Styled.InnerTextArea
          name={name}
          className={error ? 'invalid' : ''}
          placeholder={placeholder}
          value={input.value}
          onChange={input.onChange}
          onFocus={input.onFocus}
          onBlur={input.onBlur}
          aria-invalid={error}
          error={error}
        />
      </Styled.TextAreaContainer>
      {shouldShowError && (
        <Styled.Error>
          <Styled.ErrorIcon name="form-error" />
          <Styled.ErrorMessage
            dangerouslySetInnerHTML={{
              __html: error, // no need to translate error message here, cause the validator already done the translation
            }}
          />
        </Styled.Error>
      )}
    </Styled.Wrapper>
  );
};
